import { useContext } from "react";
import { ConfiguratorContext } from "../context";

const useApprovalHistoryData = () => {

    const [state, setState] = useContext(ConfiguratorContext);

    const getLastApprovalResponse = () => {
        if (state.last_preapproval.is_set) {
            const data = state.last_preapproval;
            return `Modelo: ${data.model}/Versión: ${data.version}/%pie: ${data.downpayment_percentage}/CantidadCuotas: ${data.number_fees}/Ingreso: ${data.salary}/Resultado: ${data.pre_approved_result ? 'aceptado' : 'rechazado'}`
        }

        return null;
    }
    
    const setLastApprovalResponse = (last_preapproval) => {
        setState(prevState => ({
            ...prevState,
            last_preapproval
        }));
    }

    return {
        getLastApprovalResponse,
        setLastApprovalResponse,
    }

}


export default useApprovalHistoryData;
